import type { Flow } from "@/router/types";
import { SCREENS } from "@/router/screens";

export const CANCEL: Flow = {
  [SCREENS.CANCEL]: {
    next: () => SCREENS.THANK_YOU,
    back: () => null,
  },
  [SCREENS.THANK_YOU]: {
    next: () => null,
    back: () => null,
  },
};
